import { MerchantProviderSetting } from 'types/embedded/merchantProviderSettings';

import { useMerchantProviders } from './useMerchantProviders';
import { useMerchantProviderSettings } from './useMerchantProviderSettings';

export type MerchantProviderSettingsRow = {
  id: string;
  providerName: string;
  hasSetting: boolean;
  percent?: number;
  setting?: MerchantProviderSetting;
};

type UseMerchantProviderSettingsRowsResult = {
  rows: MerchantProviderSettingsRow[];
  isPending: boolean;
  isLoading: boolean;
};

export const useMerchantProviderSettingsRows = (
  merchantId?: string,
): UseMerchantProviderSettingsRowsResult => {
  const {
    providers,
    isPending: isProvidersPending,
    isLoading: isProvidersLoading,
  } = useMerchantProviders(merchantId);
  const {
    settings,
    isPending: isSettingsPending,
    isLoading: isSettingsLoading,
  } = useMerchantProviderSettings(merchantId);

  const rows: MerchantProviderSettingsRow[] = providers.map((provider) => {
    const setting = settings.find((s) => s.provider === provider?.['@id']);

    return {
      id: provider['@id'],
      providerName: provider.name,
      hasSetting: !!setting,
      percent: setting?.percent,
      setting,
    };
  });

  return {
    rows,
    isPending: isProvidersPending || isSettingsPending,
    isLoading: isProvidersLoading || isSettingsLoading,
  };
};
